// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"479":"95d7bc45","666":"b0093186"}[chunkId] + ".chunk.js";
};